const apps = [
  // {
  //   id: "1",
  //   name: "Camera Drones",
  //   apps: [
  //     {
  //       id: "1",
  //       url: "https://www.dji.com/pl/downloads/djiapp/dji-fly",
  //       image:
  //         "https://www-cdn.djiits.com/cms_uploads/download/app/icon/26/e5895563b1eddbf6f4023272444067ca.png",
  //       name: "DJi Fly",
  //       para: "The DJI Fly app interface was designed to be simplified and ultra-intuitive. Compatible for DJI Air 3S, DJI Neo, DJI Avata 2, DJI Mini 4 Pro, DJI Air 3, DJI Mavic 3 Pro, DJI Mini 2 SE, DJI Mini 3, DJI Mavic 3 Classic, DJI Avata, DJI Mini 3 Pro, DJI Mavic 3, DJI Mini SE, DJI Air 2S, DJI FPV, DJI Mini 2, Mavic Air 2, Mavic Mini.",
  //     },
  //     {
  //       id: "2",
  //       url: "https://www.dji.com/pl/downloads/djiapp/lightcut",
  //       image:
  //         "https://www-cdn.djiits.com/cms_uploads/download/app/icon/101/7e4d0288f44bc0cce94932ff70b76976.png",
  //       name: "LightCut",
  //       para: "LightCut is a video editing app officially recommended by DJI. With rich shooting and editing functions, it perfectly fits the usage scenarios of DJI users. LightCut supports multiple hardware connections, real-time footage preview, and quick output without exporting. It provides an AI-based one-tap editing function, diverse exclusive video templates, inspirational shooting tutorials, and many other resources, making it a reliable shooting and editing tool for DJI users.",
  //     },
  //     {
  //       id: "3",
  //       url: "https://www.dji.com/pl/downloads/djiapp/dji-go-4",
  //       image:
  //         "https://www-cdn.djiits.com/cms_uploads/download/app/icon/1/28e4f33c8b0ba49080f69413ee486018.png",
  //       name: "DJI GO 4",
  //       para: "Capture the world from above. Compatible with the Mavic Series, Spark, Phantom 4, and more.",
  //     },
  //     {
  //       id: "4",
  //       url: "https://www.dji.com/pl/downloads/djiapp/dji-go-3",
  //       image:
  //         "https://www-cdn.djiits.com/cms_uploads/download/app/icon/3/ba669a00f93bed0717ed9d85dfed084f.png",
  //       name: "DJI GO",
  //       para: "Capture the world from above. Compatible with the Phantom 3 Series, Matrice Series , OSMO Series, and more.",
  //     },
  //     {
  //       id: "5",
  //       url: "https://www.dji.com/pl/downloads/djiapp/dji-virtual-flight",
  //       image:
  //         "https://www-cdn.djiits.com/cms_uploads/download/app/icon/106/fcbc5e7d2b90130275af93783d6cd32c.png",
  //       name: "DJI Virtual Flight",
  //       para: "Dear DJI User, DJI Virtual Flight will stop maintenance on March 21st, 2024. If you have already downloaded this app, you can still use it. In addition, you can choose other third-party simulators. Thank you for all your understanding and support.",
  //     },
  //   ],
  // },
  {
    id: "2",
    name: "Handheld",
    apps: [
      {
        id: "1",
        url: "https://www.dji.com/pl/downloads/djiapp/dji-mimo",
        image:
          "https://www-cdn.djiits.com/cms_uploads/download/app/icon/6/018aca94ded5cac19b217e33938385e7.png",
        name: "DJI Mimo",
        para: "As the dedicated app for DJI handheld devices, DJI Mimo offers live HD video feeds and unique, easy-to-use intelligent modes, empowering you to shoot, edit, and share your world with endless creativity.",
      },
      {
        id: "2",
        url: "https://www.dji.com/pl/downloads/djiapp/dji-ronin",
        image:
          "https://www-cdn.djiits.com/cms_uploads/download/app/icon/4/df077dfd72c499d27e7017c1ea139032.png",
        name: "DJI Ronin",
        para: "Get professional-level results with DJI RS 2, DJI RSC 2, Ronin-S, Ronin-SC, DJI RS 3 Pro, DJI RS 3, DJI RS 3 Mini, DJI RS 4, DJI RS 4 Pro, DJI SDR Transmission, DJI Focus Pro Grip, and DJI Focus Pro Hand Unit.",
      },
      {
        id: "3",
        url: "https://www.dji.com/pl/downloads/djiapp/lightcut",
        image:
          "https://www-cdn.djiits.com/cms_uploads/download/app/icon/101/7e4d0288f44bc0cce94932ff70b76976.png",
        name: "LightCut",
        para: "LightCut is a video editing app officially recommended by DJI. With rich shooting and editing functions, it perfectly fits the usage scenarios of DJI users. LightCut supports multiple hardware connections, real-time footage preview, and quick output without exporting. It provides an AI-based one-tap editing function, diverse exclusive video templates, inspirational shooting tutorials, and many other resources, making it a reliable shooting and editing tool for DJI users.",
      },
      {
        id: "4",
        url: "https://www.dji.com/pl/downloads/djiapp/dji-go-3",
        image:
          "https://www-cdn.djiits.com/cms_uploads/download/app/icon/3/ba669a00f93bed0717ed9d85dfed084f.png",
        name: "DJI GO",
        para: "Capture the world from above. Compatible with the Phantom 3 Series, Matrice Series , OSMO Series, and more.",
      },
    ],
  },
  {
    id: "3",
    name: "Specialized",
    apps: [
      {
        id: "1",
        url: "https://www.dji.com/pl/downloads/djiapp/dji-pilot",
        image:
          "https://www-cdn.djiits.com/cms_uploads/download/app/icon/5/7dcfc816e96754bf23a94c9227669855.png",
        name: "DJI Pilot",
        para: "The DJI Pilot app supports the latest DJI enterprise drones.",
      },
      {
        id: "2",
        url: "https://www.dji.com/pl/downloads/djiapp/dji-pilot-pe",
        image:
          "https://www-cdn.djiits.com/cms_uploads/download/app/icon/17/2e7c29ce20a46e0de5261291002c70b1.png",
        name: "DJI Pilot PE",
        para: "DJI Pilot PE is a customized version of the DJI Pilot flight control app, which is exclusively deployed with FlightHub on a private cloud server.",
      },
      {
        id: "3",
        url: "https://www.dji.com/pl/downloads/djiapp/ag-platform",
        image:
          "https://www-cdn.djiits.com/cms_uploads/download/app/icon/19/1741fa02fd96286494dd0ef945cc6a79.png",
        name: "DJI SmartFarm",
        para: "DJI SmartFarm App provides end-to-end service support for spraying and spreading operations. You can view data clearly on your Agras drones while controlling and managing your device with superior ease and efficiency.",
      },
      {
        id: "4",
        url: "https://www.dji.com/pl/downloads/djiapp/tello",
        image:
          "https://www-cdn.djiits.com/cms_uploads/download/app/icon/41/943d8a6651e6ffd97823fa1f5d80ac12.png",
        name: "Tello App",
        para: "Tello App can experience more flight modes of Tello, with real-time image-transmission interface and camera,video-recording functions, which can easily experience the fun of aerial-photography. Tello app can also set the parameters of the drone, upgrade the firmware and calibrate the drone. Therefore, the Tello app is an essential software for using the Tello.",
      },
      {
        id: "5",
        url: "https://www.dji.com/pl/downloads/djiapp/dji-avinox",
        image:
          "https://www-cdn.djiits.com/cms_uploads/download/app/icon/131/10990f4ad4cef67b0b0b88f502e0ccb6.png",
        name: "Avinox",
        para: "Once the Avinox app is paired with the Avinox Drive System via Bluetooth, it provides intelligent features such as bike protection and anti-theft, data recording and sharing, assist parameter adjustments, and bike status checking.",
      },
    ],
  },
  {
    id: "4",
    name: "Order & Service",
    apps: [
      {
        id: "1",
        url: "https://www.dji.com/pl/downloads/djiapp/dji-store",
        image:
          "https://www-cdn.djiits.com/cms_uploads/download/app/icon/2/371410e828a4f329fae4407d86aa478d.png",
        name: "DJI Store",
        para: "A Must-Have App for DJI Users. Get official products at launch, tracking your package whenever you want. Try Virtual Flight here, practicing before flying. Manage your devices conveniently, checking your warranty and Care anytime.",
      },
    ],
  },
  {
    id: "5",
    name: "Power",
    apps: [
      {
        id: "1",
        url: "https://www.dji.com/pl/downloads/djiapp/dji-home",
        image:
          "https://www-cdn.djiits.com/cms_uploads/download/app/icon/136/0048b5f0a630d064132f32aab889ab56.png",
        name: "DJI Home",
        para: "DJI Home is an exclusive application designed by DJI for home devices. The interface is simple and user-friendly. DJI Home can connect to devices for management and intelligent control. For example, with the DJI Power series, you can connect the device to DJI Home via Bluetooth. Through the app, you can check the device's status in real-time remotely and customize settings.",
      },
    ],
  },
];

export { apps };
